import { Component, viewChild } from '@angular/core';
import { MatMenu, MatMenuModule } from '@angular/material/menu';

import { HelpContactsComponent } from '../help-contacts/help-contacts.component';

@Component({
  selector: 'app-help-menu',
  templateUrl: './help-menu.component.html',
  imports: [MatMenuModule, HelpContactsComponent],
})
export class HelpMenuComponent {
  helpMenu = viewChild.required<MatMenu>('helpMenu');
}
